import { ProductList } from '.'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap'

export default function ProductListComponent({
  products,
  onChange,
}: {
  products: ProductList
  onChange: Function
}) {
  function setQuantity(idx: number, v: string) {
    products.get(idx)!.quantity = Number(v)
    onChange(new Map(products.entries()))
  }

  function removeProduct(id: number) {
    products.delete(id)
    onChange(new Map(products.entries()))
  }

  return (
    <table className="table table-hover">
      <thead>
        <tr>
          <th>Product ID</th>
          <th>Label</th>
          <th>Price</th>
          <th>VAT</th>
          <th>Quantity</th>
          <th>
            <strong>Total</strong>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody className="tale-group-divider">
        {products.size ? (
          ''
        ) : (
          <tr>
            <td colSpan={7} className="text-center">
              <em>No product selected</em>
            </td>
          </tr>
        )}
        {Array.from(products.entries()).map(([id, { product, quantity }]) => (
          <tr key={id}>
            <td>
              {id} <input type="hidden" />
            </td>
            <td>{product.label}</td>
            <td>{product.unit_price}</td>
            <td>{product.unit_tax}</td>
            <td>
              <input
                type="number"
                min={0}
                value={quantity}
                onChange={(e) => setQuantity(id, e.target.value)}
              />
            </td>
            <td>
              <strong>
                {(Number(product.unit_price) + Number(product.unit_tax)) *
                  quantity}
              </strong>
            </td>
            <td>
              <Button variant="danger" onClick={() => removeProduct(id)}>
                <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
